import { isNull, omitBy } from 'lodash';
import { DateTime } from 'luxon';

export const createDDBItem = (data: any) => {
  return omitBy(
    {
      name: data.name,
      description:
        data.description && data.description.length > 0
          ? data.description
          : null,
      from: DateTime.fromISO(data.range.startDate).toSeconds(),
      to: DateTime.fromISO(data.range.endDate).toSeconds(),
      notifyUserOnWebsite: data.notifyUserOnWebsite,
      is_closed: data.is_closed ?? false,
      notifyStartDate: data.notifyUserOnWebsite
        ? DateTime.fromISO(data.range.startDate)
            .minus({ days: Number(data.notifyStartDate.value) })
            .toSeconds()
        : null,
    },
    isNull,
  );
};
